import { useEffect, useState } from 'react';
import { MdCheck } from 'react-icons/md';

interface CheckBoxProps {
  name?: string;
  onChange: (value: boolean) => void;
  defaultValue?: boolean;
  disabled?: boolean;
}

export function CheckBox({ name, onChange, defaultValue = false, disabled = false }: CheckBoxProps) {
  const [checked, setChecked] = useState(defaultValue);

  useEffect(() => {
    setChecked(defaultValue);
  }, [defaultValue]);

  return (
    <div className={`w-6 h-6 relative text-sm rounded-md cursor-pointer`}>
      <input
        disabled={disabled}
        checked={checked}
        name={name || 'checkBox'}
        type="checkbox"
        onChange={(e) => {
          onChange(e.target.checked);
          setChecked(!checked);
        }}
        className={`absolute top-0 left-0 z-20 w-full h-full appearance-none cursor-pointer`}
      />
      <div
        className={`absolute top-0 left-0 w-full h-full rounded-md border transition-all flex items-center justify-center 
         ${checked ? 'border-primary bg-neutralBlue2' : 'border-neutralGray3 bg-white'} ${
          disabled && 'bg-neutralGray3 border-neutralGray3'
        } `}
      >
        {checked && <MdCheck className="text-primary text-base " />}
      </div>
    </div>
  );
}
